import http from "../http";

export const trialAccessRequest = () => http.get("trial-access");

export const trialAccessPreflightRequest = (payload) =>
  http.post("trial-access/preflight", payload);
